<template>
  <div class="root">
    <div v-if="loading" class="skeleton progress pb-5" style="height: 231px">
      <span class="sr-only">Loading Chart</span>
    </div>
    <div v-else>
      <div v-if="hasResults">
        <column-chart
          class="print-hide"
          :library="chartOptions"
          :data="chartData"
          :dataset="{ borderWidth: 0 }"
          :download="true"
          :colors="['rgba(27, 58, 89, 1)', 'rgba(63, 174, 215, 1)']"
          :legend="false"
          height="200px"
          width="100%"
        />
        <div class="legend">
          <div class="item">
            <span class="square" />
            Credits Used
          </div>
          <div class="item">
            <span class="square" />
            Users who used at least 1 credit
          </div>
        </div>
      </div>
      <div v-else class="empty">No Usage Data</div>

      <ul class="print-data-list print-only-inline">
        <li v-for="(v, k) in chartData[0].data" :key="k">
          {{ k }} <strong>{{ v }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import Vue from 'vue';
import Chartkick from 'vue-chartkick';

Vue.use(Chartkick.use(Chart));

export default {
  name: 'UsageOverTimeChart',

  props: {
    binnedFromDate: {
      type: Object,
      default: () => null
    },
    throughDate: {
      type: Object,
      default: () => null
    },
    binBy: {
      type: String,
      required: true
    },
    binnedCreditsUsed: {
      type: Array,
      default: () => []
    },
    binnedStudentsThatUsedCredits: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },

  //  data() {
  //     return {
  //       noData: Object.keys(this.chartData[0].data).length === 0,
  //     };
  //   },

  computed: {
    chartOptions() {
      return {
        animation: {
          easing: 'easeOutQuad',
          duration: 400
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          xAxes: [
            {
              offset: true,
              type: 'time',
              time: {
                unit: this.binBy,
                isoWeekday: true,
                displayFormats: { week: 'MMM D' }
              },
              gridLines: {
                display: false
              },
              display: true,
              ticks: {
                min: this.binnedFromDate ? this.binnedFromDate.format('YYYY-MM-DD') : null,
                max: this.throughDate ? this.throughDate.format('YYYY-MM-DD') : null,
                fontSize: 15,
                fontColor: '#6B6E88'
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              display: true,
              ticks: {
                fontSize: 15,
                fontColor: '#6B6E88'
              }
            }
          ]
        },
        elements: {
          borderWidth: 0,

          bar: { borderWidth: 0 }
        }
      };
    },

    chartData() {
      return [
        {
          name: 'credits used',
          data: this.binnedCreditsUsed.reduce(
            (a, e) => ({ ...a, [e.date]: e.count }),
            {}
          )
        },
        {
          name: 'users who used credits',
          data: this.binnedStudentsThatUsedCredits.reduce(
            (a, e) => ({ ...a, [e.date]: e.count }),
            {}
          )
        }
      ];
    },

    hasResults() {
      const creditsUsed = Object.keys(this.chartData[0].data).length;
      if (creditsUsed > 0) return true;
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  width: 100%;
  padding: 0 2.45rem;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1rem;
  color: #76788e;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;

  .item {
    display: inline-flex;
    margin-right: 20px;
    padding-bottom: 4px;

    .square {
      display: inline-block;
      height: 16px;
      width: 16px;
      background: $dark-blue;
      border-radius: 1px;
      margin-right: 4px;
    }

    @include use-color-list('.square');
  }
}

@media print {
  .root {
    border-bottom: 0;

    &[class^='p'] {
      padding-bottom: 0 !important;
    }
  }
}
</style>
